import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactHighmaps from 'react-highcharts/ReactHighmaps';
import HighchartsExporting from 'highcharts-exporting';
import { connect } from 'react-redux';
import {
  isExportingSelector,
  rangeBreaksSelector,
  slugSelector,
} from 'selectors/indicator';
import { countyMap as mapConfig } from 'config/mapConfig';
import { apiUrl } from 'services/fetch';
import { organizeData } from 'services/breakAndOrganizeData';
import utils from 'utils';
import { map as mapColors, noData } from 'config/colors';
import disableMapControls from 'services/disableMapControls';

const { checkStatus, parseJSON } = utils.http;

// Attaching exporting jazz to highmaps
HighchartsExporting(ReactHighmaps.Highcharts);

class CountyHighmapsWrapper extends Component {
  constructor() {
    super();

    this.requestData = this.requestData.bind(this);

    this.config = {
      ...mapConfig,
      colorAxis: {
        dataClasses: [],
      },
      chart: {
        ...mapConfig.chart,
        events: {
          load: this.requestData,
        },
      },
      series: [{
        data: [],
        mapData: mapConfig.mapData,
        joinBy: ['fips', 'fips'],
      }],
    };
  }

  componentDidUpdate() {
    this.requestData();
  }

  /**
   * Request data function
   * we are doing this here, as 1. this is a huge dataset we don't want to store in redux
   * and 2. won't exist long, in the lifecycle of the app.
   */
  requestData() {
    this.chart.showLoading();
    const { timeframe, slug, isExporting } = this.props;
    fetch(`${apiUrl()}/api/usdata/indicators/${slug}/countiesForMap/${timeframe}`)
      .then(checkStatus)
      .then(parseJSON)
      .then((json) => {
        const { buckets, data: organizedData } =
          organizeData(this.props.rangeBreaks, json, true);

        const dataClasses = buckets.map(({ idx, min, max }) => ({
          color: mapColors[idx],
          from: max,
          to: min,
        }));

        const lines = ReactHighmaps.Highcharts.geojson(
          this.config.series[0].mapData,
          'mapline'
        );
        const borderLines = ReactHighmaps.Highcharts.grep(
          lines,
          (line) => '__border_lines__' === line.properties['hc-group']
        );
        const separatorLines = ReactHighmaps.Highcharts.grep(
          lines,
          (line) => '__separator_lines__' === line.properties['hc-group']
        );

        this.chart.update({
          ...this.config,
          ...disableMapControls(isExporting),
          colorAxis: {
            dataClasses,
          },
          series: [{
            ...this.config.series[0],
            data: organizedData.map(({ bucket, fips, ...datum }) => ({
              ...datum,
              fips: 5 > fips.toString().length ? `0${fips}` : fips,
              color: 'NA' !== bucket ? mapColors[bucket] : noData,
            })),
            borderWidth: 0.5,
          }, {
            type: 'mapline',
            name: 'State Borders',
            data: borderLines,
            color: 'white',
            borderWidth: 1,
          }, {
            type: 'mapline',
            name: 'Separator',
            data: separatorLines,
            color: 'gray',
          }],
        }, true, true);
        this.chart.hideLoading();
      });
  }

  render() {
    return (
      <ReactHighmaps
        config={this.config}
        callback={(chart) => { this.chart = chart; }}
      />
    );
  }
}

CountyHighmapsWrapper.propTypes = {
  timeframe: PropTypes.oneOfType([ // eslint-disable-line react/no-unused-prop-types
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  slug: PropTypes.string.isRequired,
  rangeBreaks: PropTypes.number.isRequired,
  isExporting: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  slug: slugSelector(state),
  rangeBreaks: rangeBreaksSelector(state),
  isExporting: isExportingSelector(state),
});

export default connect(mapStateToProps)(CountyHighmapsWrapper);



// WEBPACK FOOTER //
// ./app/components/countyHighmapsWrapper/index.js